import React from 'react';
import {
  Button,
  Typography,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import moment from 'moment';

import {
  formatPriceHistoryTitle,
  normalizePriceWithPrefix,
} from '../../../lib/helpers';
import StyleBase from '../../../styles/base';

interface Props {
  priceHistory: any[];
  listingMlsId: string;
}

const useStyles = makeStyles(
  createStyles({
    content: { width: '100%', backgroundColor: '#ffffff', marginTop: 15 },
    pricehistoryText: {
      fontSize: 18,
      fontWeight: 'bold',
      color: '#323232',
      margin: 0,
    },
    toggleTextBox: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'left',
      padding: 15,
    },
    toggleText: {
      fontSize: 14,
      fontWeight: 'bold',
    },
    toggleButtonBox: {
      alignItems: 'center',
      display: 'flex',
      padding: 25,
    },
    historyDetailContainer: {
      backgroundColor: '#FFFFFF',
      border: '0.5px solid #C3CAD6',
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between',
      width: '100%',
      [StyleBase.media.mobile]: {
        borderBottom: 0,
      },
    },
    historyDetailNoBorder: {
      [StyleBase.media.mobile]: {
        borderTop: 0,
      },
    },
    historyLeftContent: {
      alignItems: 'left',
      display: 'flex',
      flex: 0.9,
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 15,
    },
    historyRightContainer: {
      alignItems: 'center',
      display: 'flex',
      flex: 0.1,
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '0 25px',
    },
    historyDetailText_1: {
      textAlign: 'left',
      fontSize: 16,
      fontWeight: 'bold',
      color: '#323232',
      padding: '4px 0',
    },
    historyDetailText_2: {
      padding: '4px 0',
      textAlign: 'left',
      fontSize: 16,
      color: '#555555',
    },
    expandButton: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      marginTop: 15,
      minWidth: 15,
      padding: 0,
    },
  }),
);

function PriceHistory({ priceHistory, listingMlsId }: Props) {
  const [showMinimum, setShowMinimum] = React.useState(true);
  const classes = useStyles();
  const _handleToggle = () => {
    setShowMinimum(!showMinimum);
  };

  const renderPriceDetails = (filterdData: any[]) => {
    return filterdData.map((data, index) => {
      return (
        <div
          key={index}
          className={`${classes.historyDetailContainer} ${
            index === 0 ? classes.historyDetailNoBorder : ''
          }`}
        >
          <div className={classes.historyLeftContent}>
            <p className={classes.historyDetailText_1}>
              {formatPriceHistoryTitle(data.status)}
            </p>
            <p className={classes.historyDetailText_2}>
              {moment(data.updateDate).format('L')}
            </p>
            <p className={classes.historyDetailText_2}>#{listingMlsId}</p>
          </div>
          <div className={classes.historyRightContainer}>
            <p className={classes.pricehistoryText}>
              {normalizePriceWithPrefix(`${data.listPrice}`)}
            </p>
          </div>
        </div>
      );
    });
  };

  const _renderDropdownToggle = (disabled: boolean) => {
    if (disabled) {
      return;
    }
    return (
      <div
        className={classes.historyDetailContainer}
        style={{ backgroundColor: '#FFFFFF', height: 76 }}
      >
        <div className={classes.toggleTextBox}>
          <Typography
            className={classes.toggleText}
            style={{
              color: '#463264',
            }}
          >
            {showMinimum ? 'See' : 'Hide'} Complete History
          </Typography>
        </div>
        <div className={classes.toggleButtonBox}>
          <Button
            disabled={disabled}
            onClick={_handleToggle}
            className={classes.expandButton}
            style={{ marginTop: 0 }}
          >
            {showMinimum ? (
              <ExpandMore style={{ color: '#463264' }} />
            ) : (
              <ExpandLess style={{ color: '#463264' }} />
            )}
          </Button>
        </div>
      </div>
    );
  };
  return (
    <div className={classes.content}>
      {renderPriceDetails(
        showMinimum ? priceHistory.slice(0, 3) : priceHistory,
      )}
      {_renderDropdownToggle(priceHistory.length <= 3 ? true : false)}
    </div>
  );
}
export default PriceHistory;
